import { Tooltip } from "@shopify/polaris"
import { observer } from "mobx-react"
import numeral from "numeral"

import stores from "@/stores"
import { formatDisplayNumber } from "@/utils/formatNumber"

const PlanBadge = () => {
  const { UserInfoStore, ReturnRequestsDataStore } = stores
  const subscribeInfo =
    ReturnRequestsDataStore.subscribe_info ?? UserInfoStore.data.subscribe_info

  if (!subscribeInfo || !subscribeInfo.package_id) return null

  const { plan_total_quota, plan_used_quota } = subscribeInfo
  const remaining = Math.max(0, plan_total_quota - plan_used_quota)
  const isReachLimit = plan_total_quota > 0 && remaining >= plan_total_quota
  const progress =
    plan_total_quota > 0
      ? Math.min(100, (remaining / plan_total_quota) * 100)
      : 0

  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <Tooltip
        content={`You have ${formatDisplayNumber(remaining)} quota available`}
        hasUnderline
        preferredPosition="below"
      >
        <span>
          Available / Total: {formatDisplayNumber(remaining)} /{" "}
          {formatDisplayNumber(plan_total_quota)}
        </span>
      </Tooltip>
      <div className="w-full h-2 rounded bg-[#e3e3e3] overflow-hidden">
        <div
          className={`h-full rounded ${isReachLimit ? "bg-[#e91b1b]" : "bg-[#91d0ff]"}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}

export default observer(PlanBadge)
